import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Box, Card, CardContent, Typography, Stack, Button, Table, TableHead, TableBody, TableRow, TableCell,
    IconButton, Chip, Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem, LinearProgress
} from '@mui/material';
import { Edit, Add } from '@mui/icons-material';
import Navbar from '../setup/Navbar';
import { fetchCategoryKitchens, assignCategoryKitchen, reset as resetCk } from '../../features/setup/categoryKitchenSlice';
import { fetchKitchens } from '../../features/setup/kitchenSlice';

export default function CategoryKitchenMapping() {
    const dispatch = useDispatch();
    const { mappings, isLoading, isError, isSuccess, message } = useSelector(state => state.categoryKitchen);
    const { kitchens } = useSelector(state => state.kitchens);

    const [dialogOpen, setDialogOpen] = useState(false);
    const [formData, setFormData] = useState({ categoryCode: '', categoryName: '', kitchenId: '' });

    useEffect(() => {
        dispatch(fetchCategoryKitchens());
        dispatch(fetchKitchens());
    }, [dispatch]);

    useEffect(() => {
        if (isSuccess && message) {
            // alert(message);
            dispatch(resetCk());
            setDialogOpen(false);
            dispatch(fetchCategoryKitchens());
        }
        if (isError && message) {
            // alert(message);
            dispatch(resetCk());
        }
    }, [isSuccess, isError, message, dispatch]);

    const unmapped = useMemo(() => mappings.filter(m => !m.kitchenId), [mappings]);

    const openDialog = (row) => {
        if (row) {
            setFormData({
                categoryCode: row.categoryCode,
                categoryName: row.categoryName,
                kitchenId: row.kitchenId || ''
            });
        } else {
            setFormData({ categoryCode: '', categoryName: '', kitchenId: '' });
        }
        setDialogOpen(true);
    };

    const handleSave = () => {
        if (!formData.categoryCode || !formData.kitchenId) {
            alert('Category and Kitchen are required');
            return;
        }
        dispatch(assignCategoryKitchen({ categoryCode: formData.categoryCode, kitchenId: formData.kitchenId, isActive: 1 }));
    };

    return (
        <>
            <Navbar />
            <Box sx={{ p: 2 }}>
                {isLoading && <LinearProgress />}
                <Card>
                    <CardContent>
                        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                            <Typography variant="h5" fontWeight="bold">Category to Kitchen Mapping</Typography>
                            <Button startIcon={<Add />} variant="contained" onClick={() => openDialog(unmapped[0] || null)}>
                                Map Category
                            </Button>
                        </Stack>

                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell><strong>Category</strong></TableCell>
                                    <TableCell><strong>Kitchen</strong></TableCell>
                                    <TableCell><strong>Printer</strong></TableCell>
                                    <TableCell><strong>Status</strong></TableCell>
                                    <TableCell align="center"><strong>Actions</strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {mappings.map((m) => (
                                    <TableRow key={m.categoryCode}>
                                        <TableCell>{m.categoryName}</TableCell>
                                        <TableCell>{m.kitchenName || '-'}</TableCell>
                                        <TableCell>{m.printerIP ? `${m.printerName || ''} ${m.printerIP}` : '-'}</TableCell>
                                        <TableCell>
                                            <Chip label={m.kitchenStatus || 'n/a'} size="small" color={m.kitchenStatus === 'active' ? 'success' : 'default'} />
                                        </TableCell>
                                        <TableCell align="center">
                                            <IconButton size="small" color="primary" onClick={() => openDialog(m)}><Edit /></IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </CardContent>
                </Card>

                <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} fullWidth maxWidth="sm">
                    <DialogTitle>Map Category to Kitchen</DialogTitle>
                    <DialogContent>
                        <Stack spacing={2} sx={{ mt: 1 }}>
                            <TextField
                                label="Category"
                                value={formData.categoryName}
                                InputProps={{ readOnly: true }}
                            />
                            <TextField
                                select
                                label="Kitchen"
                                value={formData.kitchenId}
                                onChange={(e) => setFormData({ ...formData, kitchenId: e.target.value })}
                                required
                            >
                                {kitchens.map(k => (
                                    <MenuItem key={k.kitchenId} value={k.kitchenId}>
                                        {k.kitchenName} ({k.printerIP || 'no IP'})
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Stack>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
                        <Button onClick={handleSave} variant="contained">Save</Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </>
    );
}
